const en = {
  selected: "Selected",
  more: "More",
  locked: "This template is unavailable"
};
const zh_hant = {
  selected: "已選擇模板",
  more: "更多模板",
  locked: "此模板未開放"
};
const zh_cn = {
  selected: "已选择模板",
  more: "更多模板",
  locked: "此模板未开放"
};
const es = {
  selected: "Seleccionado",
  more: "Más",
  locked: "Esta plantilla no está abierta"
};
export default {
  EN: en,
  ZH_HK: zh_hant,
  es,
  zh_cn
};
